import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminPanel from './AdminPanel';
import './style1.css';

interface AddUserProps {
    username: string | null;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const AddUser: React.FC<AddUserProps> = ({ username, onLogout }) => {
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    // Only admin can access
    if (username !== 'admin') {
        return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Access denied.</div>;
    }

    return (
        <div className="modern-layout" style={{ position: 'relative' }}>
            <header className="modern-header">
                <div className="header-container">
                    <nav className="modern-nav">
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        {onLogout && (
                            <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                        )}
                    </nav>
                </div>
            </header>
            {/* Absolutely positioned AdminPanel, does not affect main content */}
            <div
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 120, // adjust if your header is taller/shorter
                    zIndex: 10
                }}
            >
                <AdminPanel />
            </div>
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 400,
                        margin: '2rem auto',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: '0 2px 16px #6a11cb22',
                        padding: '2rem'
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Add User</h2>
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        setError('');
                        setSuccess('');
                        if (!newUsername || !newPassword) {
                            setError('Both fields are required.');
                            return;
                        }
                        try {
                            const token = localStorage.getItem('token');
                            const response = await fetch('/registeruser', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                                },
                                body: JSON.stringify({ username: newUsername, password: newPassword }),
                            });
                            if (response.ok) {
                                setSuccess('User added!');
                                setNewUsername('');
                                setNewPassword('');
                            } else {
                                const data = await response.json();
                                setError(data.message || 'Failed to add user.');
                            }
                        } catch (err) {
                            setError('Network error.');
                        }
                    }}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Username:</label>
                            <input
                                type="text"
                                value={newUsername}
                                onChange={e => setNewUsername(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Password:</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                            />
                        </div>
                        {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}
                        {success && <div style={{ color: 'green', marginBottom: '1rem' }}>{success}</div>}
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Add
                        </button>
                    </form>
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default AddUser;